import { render, staticRenderFns } from "./NewContractDetails.vue?vue&type=template&id=9228e3c0&scoped=true&"
import script from "./NewContractDetails.vue?vue&type=script&lang=js&"
export * from "./NewContractDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewContractDetails.vue?vue&type=style&index=0&id=9228e3c0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9228e3c0",
  null
  
)

export default component.exports